import React from 'react';
import {
  Accordion,
  AccordionSummary,
  AccordionDetails,
  Typography,
} from '@material-ui/core';
import ArrowDownwardIcon from '@mui/icons-material/ArrowDownward';
import { FieldValues } from '../IMSFormFieldsTypes'
import IMSFormAccordionCheckbox from './IMSFormAccordionCheckbox';
import IMSFormAccordionTextField from './IMSFormAccordionTextField';
import IMSFormAccordionNumberField from './IMSFormAccordionNumberField';
import IMSFormAccordionTextarea from './IMSFormAccordionTextarea';
import IMSFormAccordionSelect from './IMSFormAccordionSelect';
import IMSFormAccordionCheckboxGroup from './IMSFormAccordionCheckboxGroup';
import IMSFormAccordionHeading from './IMSFormAccordionHeading';
import IMSFormAccordionSubheading from './IMSFormAccordionSubheading';
import IMSFormAccordionFieldWrapper from './IMSFormAccordionFieldWrapper';
import { Group, Component } from '../imsFormTypes';

interface IMSFormAccordionItemProps {
  group: Group;
  fieldValues: FieldValues;
  handleFieldChange: (groupId: string | number, componentId: string | number, value: any, datatype: string) => void;
  shouldShowAutoPopulatedIndicator: (component: any, fieldValues: FieldValues) => boolean;
  setLightboxImage: (image: string | null) => void;
  setLightboxOpen: (open: boolean) => void;
}

const IMSFormAccordionItem: React.FC<IMSFormAccordionItemProps> = ({
  group,
  fieldValues,
  handleFieldChange,
  shouldShowAutoPopulatedIndicator,
  setLightboxImage,
  setLightboxOpen,
}) => {
  const renderComponent = (component: Component) => {
    const commonProps = {
      component,
      group,
      fieldValues,
      handleFieldChange,
      shouldShowAutoPopulatedIndicator,
    };

    switch (component.control_type) {
      case 'checkbox':
        return <IMSFormAccordionCheckbox {...commonProps} />;
      case 'textfield':
        return <IMSFormAccordionTextField {...commonProps} setLightboxImage={setLightboxImage} setLightboxOpen={setLightboxOpen}/>;
      case 'numberfield':
        return <IMSFormAccordionNumberField {...commonProps} />;
      case 'textarea':
        return <IMSFormAccordionTextarea {...commonProps} />;
      case 'select':
        return <IMSFormAccordionSelect {...commonProps} />;
      case 'checkboxgroup':
        return <IMSFormAccordionCheckboxGroup {...commonProps} />;
      case 'heading':
        return <IMSFormAccordionHeading {...commonProps} />;
      case 'subheading':
        return <IMSFormAccordionSubheading {...commonProps} setLightboxImage={setLightboxImage} setLightboxOpen={setLightboxOpen}/>;
      default:
        return null;
    }
  };

  return (
    <Accordion
      key={group.id}
      style={{
        marginBottom: '10px',
        background: '#fff',
        boxShadow: '0 4px 8px rgba(0,0,0,0.1)',
      }}
    >
      <AccordionSummary
        expandIcon={<ArrowDownwardIcon />}
        aria-controls={`panel-${group.id}-content`}
        id={`panel-${group.id}-header`}
      >
        <Typography component="h3" variant="h6" style={{ color: '#4f2682', margin: 0 }}>
          {group?.display_name || group.title}
        </Typography>
      </AccordionSummary>
      <AccordionDetails
        style={{
          padding: '10px',
          background: '#f9f9f9',
          display: 'block',
        }}
      >
        <form>
          {group?.components?.map((component) => (
            <IMSFormAccordionFieldWrapper
                key={component.id}
                component={component}
                fieldValues={fieldValues}
                shouldShowAutoPopulatedIndicator={shouldShowAutoPopulatedIndicator}
            >
                 {renderComponent(component)}
            </IMSFormAccordionFieldWrapper>
          ))}
        </form>
      </AccordionDetails>
    </Accordion>
  );
};

export default IMSFormAccordionItem;
